import { oofDtos } from '@vectronic/openApi-customer';

export class OrderStatusMapper {
  static getTitle(orderStatus: oofDtos.Order.StatusEnum): string {
    switch (orderStatus) {
      case oofDtos.Order.StatusEnum.Created:
        return 'Created';
      case oofDtos.Order.StatusEnum.AssignedToCustomer:
        return 'Assigned to Customer';
      case oofDtos.Order.StatusEnum.Submitted:
        return 'Submitted';
      case oofDtos.Order.StatusEnum.InProduction:
        return 'In Production';
      case oofDtos.Order.StatusEnum.Packed:
        return 'Packed';
      case oofDtos.Order.StatusEnum.Shipped:
        return 'Shipped';
      case oofDtos.Order.StatusEnum.Canceled:
        return 'Canceled';
      case oofDtos.Order.StatusEnum.All:
        return 'All';
      case oofDtos.Order.StatusEnum.AllUnresolved:
        return 'All Unresolved';
      default:
        return 'Unknown';
    }
  }
  static getCustomerTitle(orderStatus: oofDtos.Order.StatusEnum): string {
    switch (orderStatus) {
      case oofDtos.Order.StatusEnum.Created:
        return 'In Configuration';
      case oofDtos.Order.StatusEnum.AssignedToCustomer:
        return 'In Configuration';
      case oofDtos.Order.StatusEnum.Submitted:
        return 'Submitted';
      case oofDtos.Order.StatusEnum.InProduction:
        return 'In Production';
      case oofDtos.Order.StatusEnum.Packed:
        return 'Packed';
      case oofDtos.Order.StatusEnum.Shipped:
        return 'Shipped';
      case oofDtos.Order.StatusEnum.Canceled:
        return 'Canceled';
      case oofDtos.Order.StatusEnum.All:
        return 'All';
      default:
        return 'Unknown';
    }
  }

  static getStatusLevel(orderStatus: oofDtos.Order.StatusEnum): number {
    switch (orderStatus) {
      case oofDtos.Order.StatusEnum.Created:
        return 1;
      case oofDtos.Order.StatusEnum.AssignedToCustomer:
        return 2;
      case oofDtos.Order.StatusEnum.Submitted:
        return 3;
      case oofDtos.Order.StatusEnum.InProduction:
        return 4;
      case oofDtos.Order.StatusEnum.Packed:
        return 5;
      case oofDtos.Order.StatusEnum.Shipped:
        return 6;
      case oofDtos.Order.StatusEnum.Canceled:
        return 7;
      case oofDtos.Order.StatusEnum.All:
        return 8;
      case oofDtos.Order.StatusEnum.AllUnresolved:
        return 9;
      default:
        return 0;
    }
  }
}
